import { Form, Input, Typography } from "antd";
import { SelectWithSpinAndCustomMaxTag } from "@src/components/select/SelectWithCustomMaxTag";
import { USER_DIMENSIONS } from "@src/contexts/ab-testing/ab-test-exploration-context";
import { useLoadDimValue } from "@src/hooks/ab-testing/use-get-extra-value-field";
import React from "react";
import { useABContext } from "@src/contexts/ab-testing/ab-context";
import { ChartFormFieldsEnum } from "@src/pages/ab-test-explore/enum";
import { useGetGeneralField } from "@src/hooks/ab-testing/use-get-general-field";
import { FormInstance } from "antd/lib/form";
import { css } from "@emotion/react";

const { Text } = Typography;
export const DimensionBreakdown: React.FC<{
  form: FormInstance;
}> = ({ form }) => {
  const [isChangeBreakdownBy, setIsChangeBreakdownBy] = React.useState(false);

  const { chartForm } = useABContext();
  const funnelBreakdownWatch = Form.useWatch(ChartFormFieldsEnum.FUNNEL_BREAKDOWN, chartForm);
  const funnelBreakdownValueWatch = Form.useWatch(ChartFormFieldsEnum.FUNNEL_BREAKDOWN_VALUE, chartForm);
  const { productCode, variants, abaId, amaAppIds } = useGetGeneralField({
    form,
  });

  const { isLoading, getOptions } = useLoadDimValue({
    productCode,
    amaAppIds,
    abaId,
    dimension: [funnelBreakdownWatch],
    limit: 20,
    skip: !funnelBreakdownWatch,
    variants,
  });
  const options = isLoading ? [] : getOptions(funnelBreakdownWatch);

  React.useEffect(() => {
    if (!isChangeBreakdownBy) return;
    if (!options || options?.length === 0) {
      chartForm.setFieldValue(ChartFormFieldsEnum.FUNNEL_BREAKDOWN_VALUE, []);
      return;
    }
    chartForm.setFieldValue(
      ChartFormFieldsEnum.FUNNEL_BREAKDOWN_VALUE,
      options.slice(0, 5).map((opt) => opt.value),
    );
  }, [JSON.stringify(options), isChangeBreakdownBy]);

  React.useEffect(() => {
    form.validateFields([ChartFormFieldsEnum.FUNNEL_BREAKDOWN_VALUE + "_validate_field"]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [funnelBreakdownValueWatch]);
  return (
    <div className="flex justify-between">
      <div className="flex">
        <div className="mr-4">
          <Form.Item label="Breakdown" className="m-0">
            <SelectWithSpinAndCustomMaxTag
              value={funnelBreakdownWatch}
              allowClear
              showSearch
              options={USER_DIMENSIONS?.map((item: any) => ({ label: item, value: item }))}
              style={{ width: 250 }}
              placeholder="Breakdown by"
              onChange={(value) => {
                setIsChangeBreakdownBy(true);
                form.setFieldValue(ChartFormFieldsEnum.FUNNEL_BREAKDOWN, value);
              }}
            />
          </Form.Item>
        </div>

        <div
          style={{
            display: funnelBreakdownWatch ? "block" : "none",
          }}
        >
          <SelectWithSpinAndCustomMaxTag
            value={funnelBreakdownValueWatch}
            placeholder="Breakdown value"
            loading={isLoading}
            options={options}
            allowClear
            filterOption={(input, option: any) => {
              return (
                option?.value?.toLowerCase().includes(input.toLowerCase()) ||
                option?.label?.toLowerCase().includes(input.toLowerCase())
              );
            }}
            mode="multiple"
            showSearch
            optionRender={(opt) => {
              return (
                <div className="grid grid-flow-row-dense grid-cols-4">
                  <div className="col-span-3">{opt.label}</div>
                  <div className="col-span-1">
                    <Text disabled>{opt.data.user_count} users</Text>
                  </div>
                </div>
              );
            }}
            style={{
              width: 300,
            }}
            onChange={(value) => {
              form.setFieldValue(ChartFormFieldsEnum.FUNNEL_BREAKDOWN_VALUE, value);
            }}
          />
          <Form.Item
            css={css`
              .ant-form-item-control-input {
                display: none !important;
              }
            `}
            className="m-0 "
            label=""
            required
            name={ChartFormFieldsEnum.FUNNEL_BREAKDOWN_VALUE + "_validate_field"}
            rules={[
              {
                validator() {
                  if (!funnelBreakdownWatch) {
                    return Promise.resolve();
                  }
                  if (funnelBreakdownValueWatch?.length > 0) {
                    return Promise.resolve();
                  }
                  return Promise.reject("Value to breakdown is required!");
                },
              },
            ]}
          >
            <Input style={{ display: "none" }} hidden />
          </Form.Item>
        </div>
      </div>
    </div>
  );
};
